<script>
	import PublicDocument from '../../PublicDocument.svelte';
	export let data;
</script>

<PublicDocument document={data.document} />
